import {
  percentTextFormatter,
  percentCellFormatter,
  integerValueFormatter,
  moneyFormatterWithUnit,
  durationFormatter,
} from 'src/const/statistics/formatters';
import { EVENT_ATTRIBUTE } from 'src/const/statistics/metrics-emun';

//  Onsite 事件
// https://bytedance.feishu.cn/docs/doccnhFDgrtonsfWDdRjbFMCs7f#Ihyftm
export const EnumOnsiteEventData = [
  {
    i18nPath: 'common_basic_time_attr_onsite_shopping_roas', // 事件名 Complete Payment ROAS (Onsite)
    key: 'event_onsite_shopping_roas', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.time_attr_onsite_shopping_roas',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_shopping_roas', // 次数
        key: 'time_attr_onsite_shopping_roas', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_shopping_roas',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: durationFormatter, // 格式化表格数据
      },
      {
        key: 'time_attr_cost_per_shopping_roas', // cost_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_shopping_roas_per_click', // {metric}_per_click
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_shopping', // 事件名
    key: 'event_shopping', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_shopping',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_shopping', // 次数
        key: 'time_attr_onsite_shopping', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_shopping',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_shopping', // 单次消耗
        key: 'time_attr_cost_per_onsite_shopping', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_shopping',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_shopping_per_click', // 频率
        key: 'time_attr_onsite_shopping_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_shopping_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_shopping', // 每个Event的平均价值
        key: 'time_attr_value_per_onsite_shopping', // total_{metric}_value
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_shopping',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_shopping_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_shopping_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_shopping_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_initiate_checkout_count', // 事件名 Initiate Checkout (Onsite)
    key: 'event_view', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_initiate_checkout_count',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_initiate_checkout_count', // 次数
        key: 'time_attr_onsite_initiate_checkout_count', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_initiate_checkout_count',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_initiate_checkout_count', // 单次消耗
        key: 'time_attr_cost_per_onsite_initiate_checkout_count', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_initiate_checkout_count',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_initiate_checkout_count_per_click', // 频率
        key: 'time_attr_onsite_initiate_checkout_count_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_initiate_checkout_count_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_initiate_checkout_count', // 频率
        key: 'time_attr_value_per_onsite_initiate_checkout_count', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_initiate_checkout_count',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_initiate_checkout_count_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_initiate_checkout_count_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_initiate_checkout_count_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_on_web_detail', // 事件名 Product Details Page View (Onsite)
    key: 'event_button', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_on_web_detail',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_on_web_detail', // 次数
        key: 'time_attr_onsite_on_web_detail', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_on_web_detail',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_on_web_detail', // 单次消耗
        key: 'time_attr_cost_per_onsite_on_web_detail', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_on_web_detail',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_on_web_detail_per_click', // 频率
        key: 'time_attr_onsite_on_web_detail_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_on_web_detail_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_on_web_detail', // 每个Event的平均价值
        key: 'time_attr_value_per_onsite_on_web_detail', // total_{metric}_value
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_on_web_detail',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_on_web_detail_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_on_web_detail_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_on_web_detail_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_add_to_wishlist', // 事件名 Add to Wishlist (Onsite)
    key: 'event_consult', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_add_to_wishlist',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_add_to_wishlist', // 次数
        key: 'time_attr_onsite_add_to_wishlist', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_add_to_wishlist', // 单次消耗
        key: 'time_attr_cost_per_onsite_add_to_wishlist', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_add_to_wishlist_per_click', // 频率
        key: 'time_attr_onsite_add_to_wishlist_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_add_to_wishlist_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_add_to_wishlist', // 每个Event的平均价值
        key: 'time_attr_value_per_onsite_add_to_wishlist', // total_{metric}_value
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_add_to_wishlist_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_add_to_wishlist_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_add_to_wishlist_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_add_billing', // 事件名 Add Billing (Onsite)
    key: 'event_on_web_register', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_add_billing',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_add_billing', // 次数
        key: 'time_attr_onsite_add_billing', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_add_billing',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_add_billing', // 单次消耗
        key: 'time_attr_cost_per_onsite_add_billing', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_add_billing',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_add_billing_per_click', // 频率
        key: 'time_attr_onsite_add_billing_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_add_billing_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_add_billing', // 每个Event的平均价值
        key: 'time_attr_value_per_onsite_add_billing', // total_{metric}_value
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_add_billing',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_add_billing_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_add_billing_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_add_billing_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_on_web_cart', // 事件名 Add to Cart (Onsite)
    key: 'event_on_web_detail', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_on_web_cart',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_on_web_cart', // 次数
        key: 'time_attr_onsite_on_web_cart', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_on_web_cart',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_on_web_cart', // 单次消耗
        key: 'time_attr_cost_per_onsite_on_web_cart', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_on_web_cart',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_on_web_cart_per_click', // 频率
        key: 'time_attr_onsite_on_web_cart_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_on_web_cart_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_on_web_cart', // 每个Event的平均价值
        key: 'time_attr_value_per_onsite_on_web_cart', // total_{metric}_value
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_on_web_cart',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_on_web_cart_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_on_web_cart_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_on_web_cart_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_form', // 事件名 Form Submission (Onsite)
    key: 'event_on_web_cart', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_form',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_form', // 次数
        key: 'time_attr_onsite_form', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_form',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_form', // 单次消耗
        key: 'time_attr_cost_per_onsite_form', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_form',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_form_per_click', // 频率
        key: 'time_attr_onsite_form_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_form_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_time_attr_value_per_onsite_form', // 每个Event的平均价值
        key: 'time_attr_value_per_onsite_form', // total_{metric}_value
        hoverKey: 'campaign_hover_stat_data.time_attr_value_per_onsite_form',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_total_onsite_form_value', // 总付费价值 / 100000
        key: 'time_attr_total_onsite_form_value', // value_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_total_onsite_form_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_basic_onsite_download_start', // 事件名 App Store Click (Onsite)
    key: 'event_on_web_order', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_onsite_download_start',
    children: [
      {
        i18nPath: 'common_time_attr_onsite_download_start', // 次数
        key: 'time_attr_onsite_download_start', // {metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_download_start',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_time_attr_cost_per_onsite_download_start', // 单次消耗
        key: 'time_attr_cost_per_onsite_download_start', // cost_per_{metric}
        hoverKey: 'campaign_hover_stat_data.time_attr_cost_per_onsite_download_start',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_time_attr_onsite_download_start_per_click', // 频率
        key: 'time_attr_onsite_download_start_per_click', // {metric}_per_click
        hoverKey: 'campaign_hover_stat_data.time_attr_onsite_download_start_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
    ],
  },
  {
    i18nPath: 'common_basic_ix_page_view_count', // 事件名 Page Views (Onsite)
    key: 'event_ix_page_view', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_ix_page_view_count',
    // hoverKey: 'campaign_hover_stat_data.basic_ix_page_view_count',
    children: [
      {
        i18nPath: 'common_ix_page_view_count', // 次数
        key: 'ix_page_view_count', // {metric}
        hint: 'campaign_hover_stat_data.ix_page_view_count',
        // hoverKey: 'campaign_hover_stat_data.initiate_checkout',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_cost_per_ix_page_view_count', // 单次消耗
        key: 'cost_per_ix_page_view_count', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_ix_page_view_count',
        // hoverKey: 'campaign_hover_stat_data.cost_per_initiate_checkout',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_ix_page_view_count_per_click', // 开始下单率
        key: 'ix_page_view_count_per_click',
        hint: 'campaign_hover_stat_data.ix_page_view_count_per_click',
        // hoverKey: 'campaign_hover_stat_data.initiate_checkout_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
    ],
  },
  {
    i18nPath: 'common_basic_ix_button_click_count', // 事件名 Call-to-Action Button Clicks (Onsite)
    key: 'event_ix_button_click', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_ix_button_click_count',
    // hoverKey: 'campaign_hover_stat_data.event_add_billing',
    children: [
      {
        i18nPath: 'common_ix_button_click_count', // 次数
        key: 'ix_button_click_count', // {metric}
        hint: 'campaign_hover_stat_data.ix_button_click_count',
        // hoverKey: 'campaign_hover_stat_data.add_billing',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_cost_per_ix_button_click_count', // 单次消耗 支付信息成本
        key: 'cost_per_ix_button_click_count', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_ix_button_click_count',
        // hoverKey: 'campaign_hover_stat_data.cost_per_add_billing',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_ix_button_click_count_per_click', // 支付信息率
        key: 'ix_button_click_count_per_click',
        hint: 'campaign_hover_stat_data.ix_button_click_count_per_click',
        // hoverKey: 'campaign_hover_stat_data.add_billing_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
    ],
  },
  {
    i18nPath: 'common_basic_ix_product_click_count', // 事件名 Product Clicks (Onsite)
    key: 'event_ix_product_click', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.basic_ix_product_click_count',
    // hoverKey: 'campaign_hover_stat_data.event_search',
    children: [
      {
        i18nPath: 'common_ix_product_click_count', // 次数
        key: 'ix_product_click_count', // {metric}
        hint: 'campaign_hover_stat_data.ix_product_click_count',
        // hoverKey: 'campaign_hover_stat_data.search',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_cost_per_ix_product_click_count', // 单次搜索成本
        key: 'cost_per_ix_product_click_count', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_ix_product_click_count',
        // hoverKey: 'campaign_hover_stat_data.cost_per_search',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_ix_product_click_count_per_click', // 搜索率
        key: 'ix_product_click_count_per_click',
        hint: 'campaign_hover_stat_data.ix_product_click_count_per_click',
        // hoverKey: 'campaign_hover_stat_data.search_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
    ],
  },
];
